module.exports = Object.assign({}, require('./base/_format'), {});